import React from 'react';
import './InsuranceTaxiPage.css';
import taxiImage from './InsuranceTaxiPageimage.png';
import InsuranceTestimonialsCarousel from './InsuranceTestimonialsCarousel';
import AutoScallingyad2taxiforsale from "../../components/AutoScallingyad2taxiforsale/AutoScallingyad2taxiforsale";
import NewTaxisHomePageCards from "../../components/NewTaxisHomePageCards/NewTaxisHomePageCards";
import { FaHandPointer } from "react-icons/fa";
import CallBarMoshe from './CallBarMoshe';
import { Helmet } from "react-helmet";
import ContactInsuranceForm from './ContactInsuranceForm';
import ArticlesPreview from "../../components/ArticlesPreviewBlog/ArticlesPreviewBlog";
import { FaWhatsapp } from "react-icons/fa";

const InsuranceTaxiPage = () => {
  return (
    <>
    <Helmet>
  {/* Title & Description */}
  <title>ביטוח מונית עם משה ציון | קנה טקסי - ביטוח חובה, צד ג' ומקיף</title>
  <meta name="description" content="משה ציון, סוכן ביטוח מומלץ לנהגי מוניות מטעם BuyTaxi - קבלו הצעת מחיר לביטוח מונית: חובה, צד ג' ומקיף, בהתאמה אישית עם שירות מקצועי וזמינות מלאה." />

  {/* Open Graph (Facebook, WhatsApp, LinkedIn) */}
  <meta property="og:title" content="משה ציון | ביטוח מוניות | קנה טקסי - BuyTaxi" />
  <meta property="og:description" content="מחפשים ביטוח למונית? קבלו הצעה משתלמת ממשה ציון, הסוכן הרשמי של קנה טקסי. ביטוח חובה, צד ג', מקיף ושירות אישי לנהגי מוניות!" />
  <meta property="og:image" content="%PUBLIC_URL%/moshe-insurance-og.jpg" />
  <meta property="og:url" content="https://buytaxi.co.il/insurance" />
  <meta property="og:type" content="website" />

  {/* Twitter Meta Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="ביטוח מונית עם משה ציון | קנה טקסי - BuyTaxi" />
  <meta name="twitter:description" content="הצעה לביטוח מונית בהתאמה אישית: ביטוח חובה, צד ג', מקיף – באישור משרד התחבורה. שירות אישי לנהגי מוניות בישראל." />
  <meta name="twitter:image" content="%PUBLIC_URL%/moshe-insurance-og.jpg" />
  <meta name="twitter:site" content="@buytaxi" />

  {/* Keywords - מילות מפתח פסיכיות לביטוח מוניות */}
  <meta name="keywords" content="ביטוח למונית, ביטוח מונית חובה, ביטוח מקיף למונית, ביטוח צד ג למונית, ביטוח מוניות בישראל, ביטוח נהגי מוניות, סוכן ביטוח למונית, הצעת מחיר ביטוח מונית, משה ציון ביטוח, BuyTaxi ביטוח מונית, קנה טקסי ביטוח רכב, השוואת ביטוחי מוניות, ביטוח זול למונית, ביטוח מסחרי לרכב מונית, סוכן ביטוח מוניות מומלץ, ביטוח רכב להסעת נוסעים בשכר, ביטוחי רכב מונית 2025, ביטוח מונית לשנה, תעריפים ביטוח למוניות, מחיר ביטוח מונית חובה, משה ציון קנה טקסי, משה ביטוח מוניות, סוכן ביטוח אישי לנהגי מוניות" />

  {/* Canonical */}
  <link rel="canonical" href="https://buytaxi.co.il/insurance" />
</Helmet>
      {/* המלצת האתר מעל כל הקומפוננטה */}
      <div className="InsuranceTaxiPageRecommendationWrapper">
        <p className="InsuranceTaxiPageRecommendation">
          ⚡ מומלץ ע"י קנה טקסי: סוכן הביטוח המומלץ שלנו לנהגי מוניות.  דירוג של 9.4 | משה ציון
        </p>
      </div>

      {/* תוכן העמוד */}
      <div className="InsuranceTaxiPageContainer">
        <div className="InsuranceTaxiPageContent">
          <div className="InsuranceTaxiPageTextSection">
            <h1 className="InsuranceTaxiPageTitle">ביטוח מונית בראש שקט</h1>
            <p className="InsuranceTaxiPageDescription">
              משה ציון – סוכן ביטוח אישי לנהגי מוניות. ביטוח חובה, צד ג׳ ומקיף – מותאם במיוחד לך, עם שירות אישי וזמינות מלאה.
            </p>
    <div className="InsuranceTaxiPageCTA">
      <div className="InsuranceTaxiPageCTA-header">
<a
  href="https://wa.me/972509139000?text=היי%20מעוניין%20לקבל%20הצעת%20מחיר%20לביטוח%20למונית%20דרך%20האתר%20קנה%20טקסי"
  target="_blank"
  rel="noopener noreferrer"
  className="InsuranceTaxiPageCTA-wrapper"
  onClick={() => {
    if (window.gtag) {
      window.gtag("event", "whatsapp_moshe", {
        event_category: "Insurance CTA",
        event_label: "WhatsApp Wrapper Click",
        value: 1,
      });
    }
  }}
>
  <div className="InsuranceTaxiPageCTA">
    <div className="InsuranceTaxiPageCTA-header">
      <h2 className="InsuranceTaxiPageCTA-title">הצעה בצ'יק בוואטספ</h2>
      <div className="InsuranceTaxiPageCTA-button">
        <FaWhatsapp className="InsuranceTaxiPageCTA-icon" />
      </div>
      </div>
      <p className="InsuranceTaxiPageCTA-subtext">
        שלחו הודעה עם הפרטים שלכם – ותקבלו הצעה משתלמת תוך דקות!
      </p>
    </div>

</a>

      </div>
    </div>



          </div>
          <div className="InsuranceTaxiPageImageSection">
            <img
              src={taxiImage}
              alt="Taxi Insurance"
              className="InsuranceTaxiPageImage"
            />
          </div>
        </div>
        
      </div>
      <div className="TaxiInsuranceArticleWrapper">

  <h1 className="TaxiInsuranceArticleTitle">המדריך המקיף לבחירת ביטוח מונית בישראל</h1>

  <p className="TaxiInsuranceArticleIntro">
    כל נהג מונית בישראל יודע – ביטוח נכון הוא לא רק חובה חוקית, אלא גם שקט נפשי, יציבות כלכלית וביטחון אישי.
    במדריך זה תמצאו מידע עשיר ומעמיק על כל סוגי הביטוחים, ההבדלים ביניהם, המלצות מניסיון נהגים ותיקים, והסברים איך לבחור את הפוליסה הנכונה ביותר עבורכם.
  </p>

  <h2 className="TaxiInsuranceSectionTitle">סוגי הביטוחים שמגיעים לכל נהג מונית</h2>

  <h3 className="TaxiInsuranceSubsectionTitle">ביטוח חובה לרכב מונית</h3>
  <p className="TaxiInsuranceParagraph">
    ביטוח חובה הוא דרישת יסוד בחוק. עבור נהגי מוניות, הוא כולל לא רק את הנהג עצמו אלא גם את הנוסעים.
    חשוב לוודא שהכיסוי תואם להסעת נוסעים בתשלום, שכן זה נחשב פעילות עסקית, ולא כיסוי פרטי רגיל.
  </p>

  <h3 className="TaxiInsuranceSubsectionTitle">ביטוח צד ג' – מגן עליך במצבי נזק לרכוש צד שלישי</h3>
  <p className="TaxiInsuranceParagraph">
    מדובר בביטוח שמכסה אותך מפני תביעות בגין נזק לרכוש של אחרים. לדוגמה: פגיעה ברכב אחר, נזק לעמוד, גדר, או רכוש עירוני.
    בבחירת פוליסה זו, חשוב לבדוק מה גובה הכיסוי המקסימלי וכמה השתתפות עצמית תחול עליך במקרה של תאונה.
  </p>

  <h3 className="TaxiInsuranceSubsectionTitle">ביטוח מקיף – המעטפת השקטה שלך</h3>
  <p className="TaxiInsuranceParagraph">
    ביטוח מקיף מציע את הכיסוי הרחב ביותר: נזקי תאונה, גניבה, פריצה, אש, התהפכות, נזקי מזג אוויר ואפילו רעידות אדמה.
    לנהג מונית שמבלה שעות רבות בכביש – מדובר בהשקעה נבונה שיכולה לחסוך הוצאות לא צפויות של עשרות אלפי שקלים.
  </p>

  <h2 className="TaxiInsuranceSectionTitle">השוואת כיסויים בין סוגי הביטוחים</h2>

  <div className="TaxiInsuranceTableContainer">
    <table className="TaxiInsuranceTable">
      <thead>
        <tr>
          <th>סוג הביטוח</th>
          <th>כיסויים כלולים</th>
          <th>האם חובה?</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>ביטוח חובה</td>
          <td>פגיעות גוף לנהג, נוסעים ועוברי אורח</td>
          <td>כן</td>
        </tr>
        <tr>
          <td>ביטוח צד ג'</td>
          <td>נזק לרכוש צד שלישי (רכבים, מבנים, תשתיות)</td>
          <td>לא, אך מומלץ בחום</td>
        </tr>
        <tr>
          <td>ביטוח מקיף</td>
          <td>תאונה עצמית, גניבה, שריפה, מזג אוויר, רכב חלופי</td>
          <td>לא, אך מספק שקט נפשי מלא</td>
        </tr>
      </tbody>
    </table>
  </div>

  <h2 className="TaxiInsuranceSectionTitle">מה חשוב לבדוק לפני שסוגרים פוליסת ביטוח?</h2>
  <ul className="TaxiInsuranceList">
    <li className="TaxiInsuranceListItem">גובה ההשתתפות העצמית</li>
    <li className="TaxiInsuranceListItem">האם קיים שירות רכב חלופי</li>
    <li className="TaxiInsuranceListItem">זמינות מוקד תביעות 24/7</li>
    <li className="TaxiInsuranceListItem">האם קיימת השתתפות במקרה של טוטאל לוס</li>
    <li className="TaxiInsuranceListItem">כיסוי לרכב בנהיגה של נהג נוסף</li>
    <li className="TaxiInsuranceListItem">משך תקופת הביטוח – חודשי / שנתי</li>
  </ul>

  <h2 className="TaxiInsuranceSectionTitle">שאלות נפוצות – כל מה שנהגי מוניות באמת שואלים</h2>

  <div className="TaxiInsuranceFAQ">
    <div className="TaxiInsuranceQuestion">
      <h4 className="TaxiInsuranceQuestionTitle">האם ביטוח צד ג' מתאים גם להסעות ילדים?</h4>
      <p className="TaxiInsuranceAnswer">
        לא בהכרח. במקרה של הסעת ילדים, יש לוודא שהפוליסה מכסה גם את זה – חלק מהחברות דורשות הרחבה ייעודית.
      </p>
    </div>

    <div className="TaxiInsuranceQuestion">
      <h4 className="TaxiInsuranceQuestionTitle">האם ביטוח מקיף כולל שירותי דרך?</h4>
      <p className="TaxiInsuranceAnswer">
        תלוי בחברת הביטוח. יש חברות שמציעות שירותי דרך כחלק מהביטוח המקיף, ויש כאלה שגובות עליו תוספת נפרדת.
      </p>
    </div>

    <div className="TaxiInsuranceQuestion">
      <h4 className="TaxiInsuranceQuestionTitle">האם אפשר לשלם ביטוח מונית בתשלומים?</h4>
      <p className="TaxiInsuranceAnswer">
        בהחלט. מרבית חברות הביטוח מאפשרות פריסה נוחה של התשלום עד 12 תשלומים – שימו לב לעמלות נלוות.
      </p>
    </div>

    <div className="TaxiInsuranceQuestion">
      <h4 className="TaxiInsuranceQuestionTitle">מה ההבדל בין ביטוח רכב פרטי לביטוח מונית?</h4>
      <p className="TaxiInsuranceAnswer">
        ביטוח מונית מתייחס לרכב שנמצא בשימוש עסקי לצורך הסעת נוסעים בתשלום – הכיסוי, הסיכון והעלויות שונים באופן מהותי.
      </p>
    </div>
  </div>

  <h2 className="TaxiInsuranceSectionTitle">לסיום – ההמלצה שלנו</h2>
  <p className="TaxiInsuranceSummary">
    ביטוח למונית זה לא רק "עוד הוצאה" – זו החלטה אסטרטגית שתשפיע על הכיס שלך, על איכות השירות שלך כלפי הנוסעים, ועל היכולת שלך לנהוג בראש שקט.
    אנחנו ב־BuyTaxi ממליצים בלב שלם על משה ציון – סוכן ביטוח מומחה שמכיר כל סעיף, כל כיסוי, וכל נהג.
    דבר איתו עוד היום ותן לו לבנות עבורך פוליסה שתשמור עליך באמת.
  </p>
<p className="TaxiInsuranceAIDisclaimer">
  🧠 שים לב: מאמר זה נכתב בעזרת בינה מלאכותית (AI) והוא למטרות מידע בלבד. תמיד מומלץ להתייעץ עם סוכן ביטוח מוסמך לפני קבלת החלטות.
</p>

</div>
<div className="InsurancePageCarouselSection">
  <InsuranceTestimonialsCarousel />
</div>
<div className="InsurancePageContactSection">
  <h2 className='InsuranceTaxiContactPageTitle'>השאר פרטים ונציג יחזור אלייך בהקדם</h2>
  <ContactInsuranceForm />
</div>
  <div className="AutoScallingyad2taxiforsaleh4">
      <h2>מגוון מוניות יד 2 מחכות רק לך!</h2>
    </div>
  <div className="AutoScallingIconsHomepage">
      <AutoScallingyad2taxiforsale />
    </div>
    <div className="swipe-hint mobile-only">
  <FaHandPointer className="swipe-icon" />
  <span className="swipe-text">דפדף ימינה</span>
</div>
<div className="NewTaxisHomePageCardsAtPageDiv2">
  <NewTaxisHomePageCards />
  <button className="hero-button-InsurancePage" onClick={() => window.location.href = '/AllTaxiYad2ForSalepage'}>למאגר המוניות</button>
</div>
<div className="ArticlesPreviewInsurancePage">
  <ArticlesPreview />
</div>
<CallBarMoshe />

    </>
  );
};

export default InsuranceTaxiPage;
